var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshopOwner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.887,
    height: 71.551,
    viewBox: "0 0 77.887 71.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .workshop-a{fill:#00943e;}\n            .workshop-b{fill:#fff;}\n            .workshop-c,.workshop-d{stroke:#00943e;stroke-miterlimit:10;stroke-width:2px;}\n            .workshop-d{fill:none;stroke-linecap:round;stroke-linejoin:round;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.87)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "workshop-a",
    d: "M9.9,56.649l12.2.043a1.278,1.278,0,0,0,1.282-1.274l.026-8.353a1.278,1.278,0,0,0-1.274-1.282l-12.2-.043a1.278,1.278,0,0,0-1.282,1.274L8.63,55.366A1.278,1.278,0,0,0,9.9,56.649ZM11.212,48.3l9.644.035-.017,5.8-9.644-.035Z",
    transform: "translate(-1.152 -11.792)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "workshop-a",
    d: "M39.606,55.076,2.547,54.948,2.608,36.9a5.006,5.006,0,0,1,1.6-3.662l3.423-3.085,32.068.11.009-2.541-4.02-.017a.738.738,0,0,0,0-.2A10.746,10.746,0,0,0,14.2,27.442a.738.738,0,0,0,0,.2l-5.892-.025,3.544-14a7.262,7.262,0,0,1,7.122-5.481l20.8.068.009-2.515L18.95,5.62a9.8,9.8,0,0,0-9.618,7.393L5.485,28.555v.068l-2.972,2.8A7.548,7.548,0,0,0,.1,36.891L0,63.038a3.38,3.38,0,0,0,3.4,3.357l10.233.034A3.381,3.381,0,0,0,17.052,63.1l.017-5.583,22.528.076ZM16.757,27.484a8.185,8.185,0,0,1,16.368.059,1.54,1.54,0,0,0,.035.2l-16.4-.059ZM14.453,63.1a.844.844,0,0,1-.858.833L3.362,63.9a.844.844,0,0,1-.849-.841l.017-5.591,11.94.042Z",
    transform: "translate(0 -5.62)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "workshop-b",
    width: 14.297,
    height: 71.501,
    transform: "translate(30.926 0.003) rotate(0.202)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "workshop-c",
    y2: 64.248,
    transform: "translate(34.089 1.456)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.383 6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "workshop-d",
    d: "M56.781,70.551H50.62a2.533,2.533,0,0,1-2.53-2.53V49.86a2.533,2.533,0,0,1,2.53-2.53h6.161a2.533,2.533,0,0,1,2.53,2.53V68.013A2.535,2.535,0,0,1,56.781,70.551Z",
    transform: "translate(-48.09 -14.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "workshop-d",
    d: "M57.706,46.738H50.28V44.832a1.875,1.875,0,0,1,1.872-1.872h3.682a1.875,1.875,0,0,1,1.872,1.872v1.906Z",
    transform: "translate(-48.382 -13.165)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 2.365,
    transform: "translate(4.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "workshop-d",
    d: "M55.866,18.51V39.7H52.79V18.51",
    transform: "translate(-48.718 -9.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "workshop-d",
    d: "M55.537,17.079l2.132-1.854L55.537,7.79H52.461L50.33,15.224l2.131,1.854",
    transform: "translate(-48.389 -7.79)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.166)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "workshop-d",
    d: "M75.513,23.525A8.68,8.68,0,0,1,74.958,7.79",
    transform: "translate(-70.21 -7.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "workshop-d",
    d: "M84.655,7.79A8.674,8.674,0,0,1,84.1,23.516",
    transform: "translate(-72.065 -7.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "workshop-d",
    d: "M83.532,7.79v5.19a2.622,2.622,0,0,1-2.617,2.625H78.307A2.616,2.616,0,0,1,75.69,12.98V7.79",
    transform: "translate(-70.942 -7.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "workshop-d",
    d: "M76.329,25.949,76.32,64.324a3.369,3.369,0,0,0,3.371,3.371h0a3.369,3.369,0,0,0,3.371-3.371c0-9.93.009-38.384.009-38.384",
    transform: "translate(-71.026 -11.41)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopOwner);
export default __webpack_public_path__ + "static/media/workshop-owner.d8d34e5c2034343751e963f684e25147.svg";
export { ForwardRef as ReactComponent };